import type { ApiClient } from './client';

export type EncodingMode = 'full' | 'skip-static';
export type Resolution = 'native' | '720p' | '540p' | '360p';
export type Codec = 'jpeg' | 'h264';

export interface CreateSessionRequest {
  hostId: string;
  monitorId: number;
  accessCode?: string;
  encoding?: EncodingMode;
  resolution?: Resolution;
  codec?: Codec;
  // Viewer-chosen capture knobs. Omitted = relay default (20 / 75).
  fps?: number;
  jpegQuality?: number;
}

export interface CreateSessionResponse {
  sessionId: number;
  state: 'CONNECTING';
  mediaUrl: string;
  mediaToken: string;
  codec: Codec;
}

export function createSession(
  api: ApiClient,
  body: CreateSessionRequest,
  signal: AbortSignal,
): Promise<CreateSessionResponse> {
  const payload = {
    hostId: body.hostId,
    monitorId: body.monitorId,
    accessCode: body.accessCode ?? null,
    encoding: body.encoding ?? 'full',
    resolution: body.resolution ?? 'native',
    codec: body.codec ?? 'jpeg',
    fps: body.fps ?? 20,
    jpegQuality: body.jpegQuality ?? 75,
  };
  return api.request<CreateSessionResponse>('POST', '/api/sessions', { body: payload, signal });
}
